import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";
import { canAccessPage, canManageUsers } from "@/lib/access";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=guest, object=auth
  const [roles, setRoles] = useState([]);

  useEffect(() => {
    const token = localStorage.getItem("srm_token");
    if (!token) {
      setUser(false);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => setUser(false));
  }, []);

  useEffect(() => {
    if (user) api.get("/auth/roles").then((r) => setRoles(r.data.roles)).catch(() => {});
  }, [user]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("srm_token", data.access_token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("srm_token");
    setUser(false);
    window.location.href = "/login";
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        setUser,
        roles,
        login,
        logout,
        canPage: (path) => canAccessPage(user?.role, path),
        canManageUsers: canManageUsers(user?.role),
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
